import { render, staticRenderFns } from "./ModalEditKategori.vue?vue&type=template&id=66e5dd3e&scoped=true&"
import script from "./ModalEditKategori.vue?vue&type=script&lang=js&"
export * from "./ModalEditKategori.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditKategori.vue?vue&type=style&index=0&id=66e5dd3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5dd3e",
  null
  
)

export default component.exports